/**
 * New-client onboarding bootstrap: starts the firm's Onboarding workflow.
 */

import { autoStartOnboardingWorkflows } from './workflowsApi';

export async function bootstrapAdviceJourneyForClient({
  clientId,
  clientData,
  userEmail,
}) {
  if (!clientId || !clientData || !userEmail) return;

  // New clients are onboarded by their firm's auto-start Onboarding workflow
  // only — the legacy onboarding domain is never seeded. When no workflow can
  // start yet (no firm, no template, or a failure) the server marks the client
  // pending and the first firm assignment retries (see updateClientRecord).
  try {
    await autoStartOnboardingWorkflows(clientId, { trigger: 'created' });
  } catch (err) {
    console.error('Onboarding workflow auto-start failed:', err);
  }
}
